module.exports = __webpack_public_path__ + "img/Fromagerie_2.f172c688.jpg";